import { Modal as AntModal } from 'antd';
import { Button } from 'components/common';
import { ModalHeader, ModalRow, ModalValue } from '../styled';
import { getResearcherText } from 'utils/constants';

const ViewCRMSummary = ({ open, selectedCRM, onClose }) => {
  if (!selectedCRM) return null;

  return (
    <AntModal
      open={open}
      title='CRM Push Summary'
      onCancel={onClose}
      footer={[
        <Button key='cancel' onClick={onClose}>
          Cancel
        </Button>,
      ]}
    >
      <div>
        We have completed pushing SciLeads list <b>{selectedCRM.term}</b>
        {selectedCRM.crmListName && (
          <>
            {' '}
            to <b>{selectedCRM.crmListName}</b>
          </>
        )}
      </div>

      <ModalHeader>
        <ModalRow>
          <b>{`${getResearcherText({
            isPlural: true,
            capitalize: true,
          })} selected to push:`}</b>
          <ModalValue>{selectedCRM.researchersPushed}</ModalValue>
        </ModalRow>
        <ModalRow>
          <b>{`${getResearcherText({
            isPlural: true,
            capitalize: true,
          })} not pushed:`}</b>
          <ModalValue>{selectedCRM.researchersNotPushed}</ModalValue>
        </ModalRow>
        <ModalRow>
          <b>Existing contacts found:</b>
          <ModalValue>{selectedCRM.existingContactsFound}</ModalValue>
        </ModalRow>
        <ModalRow>
          <b>New contacts created:</b>
          <ModalValue>{selectedCRM.newContactsCreated}</ModalValue>
        </ModalRow>
        <ModalRow>
          <b>Contacts linked to campaign/list:</b>
          <ModalValue>{selectedCRM.contactsLinkedToList}</ModalValue>
        </ModalRow>
        <ModalRow>
          <b>{`${getResearcherText({
            isPlural: true,
            capitalize: true,
          })} skipped (no email):`}</b>
          <ModalValue>{selectedCRM.researchersSkippedNoEmail}</ModalValue>
        </ModalRow>
        <ModalRow>
          <b>{`${getResearcherText({
            isPlural: true,
            capitalize: true,
          })} skipped (inactive):`}</b>
          <ModalValue>{selectedCRM.researchersSkippedInactive}</ModalValue>
        </ModalRow>
        {selectedCRM.researchersSkippedPreviouslyExported >= 0 && (
          <ModalRow>
            <b>{`${getResearcherText({
              isPlural: true,
              capitalize: true,
            })} skipped (previously exported):`}</b>
            <ModalValue>
              {selectedCRM.researchersSkippedPreviouslyExported}
            </ModalValue>
          </ModalRow>
        )}
      </ModalHeader>
    </AntModal>
  );
};

export default ViewCRMSummary;
